export const salesPriceTargets = {type: 'salesPrice', timespan: 'month'};

export const offerCountTargets = {type: 'offerCount', timespan: 'month'};
